<template>
    <div id="orderItemEdit" class="production-plan-edit">
        <div style="margin-left:20px">
        <el-row>
            <el-row class="operateBtn-wrap" style="margin-top:0px;">
                <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="backToOrderItemView">返回</el-button>
            </el-row>
        </el-row>
        
        <el-row style="margin-top: 10px;">
            <span class="label">订单号：</span>
            <span class="value" style="width:210px">{{selectedSplit.orderCode?selectedSplit.orderCode:selectedSplit.orderCode}}</span>

            <span class="label">下单日期：</span>
            <span class="value" style="width:210px">{{selectedSplit.orderTime}}</span>

            <span class="label" >交付日期：</span>
            <span class="value" >{{selectedSplit.deliverTime}}</span>
            
            <span class="label">订单状态：</span>
            <span class="value">{{selectedSplit.parseStateText}}</span>
        </el-row>

        <el-row style="margin-top: 10px;">
            <span class="label">物料编码：</span>
            <span class="value" style="width:210px">{{selectedSplit.orderRowMaterialCode}}</span>

            <span class="label">物料名称：</span>
            <span class="value" style="width:210px">{{selectedSplit.orderRowMaterialName}}</span>

            <span class="label" >物料规格：</span>
            <span class="value" >{{selectedSplit.orderRowSpecification}}</span>
            
            <span class="label">数量：</span>
            <span class="value">{{selectedSplit.orderRowCount}} </span>
        </el-row>

        <el-row style="margin-top: 10px;">
            <span class="label">订单备注：</span>
            <span class="value" style="width:210px">{{selectedSplit.remark}}</span>
        </el-row>
        </div>
        
        <div v-for="(item,index) in orderItemList" :key='index'>
            <OrderItemBaseView :baseData.sync='item' :key='index'></OrderItemBaseView>
        </div>
    </div>
</template>

<script>
import CommonUtils from '@/util/CommonUtils'
import OrderItemBaseView from './OrderItemBaseView.vue'
export default {
    name: 'OrderItemView',
    props: {
        selectedSplit: Object,
    },
    components:{
        OrderItemBaseView
    },
    data() {
        return {
            orderItemList:[],
            
            loading: false,
            W: false,
            
            fristEdit: true,  //默认第一次编排任务
            permission: JSON.parse(localStorage.getItem("permission")),
        }
    },
    
    beforeMount: async function () {
        this.loadOrderItemPlan()
        
    },

    //完成挂载
    mounted: function () {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        
    },

    //更新dom时触发

    computed: {
        
    },

    methods: {
        loadOrderItemPlan(){
            this.$RequestUtil.get({
                url: '/api/productionPlan/listBatchPartProcessByPartPlan',
                type: 'sync',
                params: {
                    businessOrderItemId:this.selectedSplit.businessOrderItemId,
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.orderItemList = res.data
                    } else {
                        this.$message.error(res.msg || res.message)
                    }
                }
            })
        },
        backToOrderItemView(){
            this.$parent.showPage = 1
        },
    },
    watch: {
       
    },
}
</script >

<style scoped>
    .operateBtn-wrap {
        margin-top: 20px;
    }
    .label {
        display: inline-block;

        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #606266;
    }
    .value {
        display: inline-block;
        width: 200px;
        line-height: 32px;
        font-size: 14px;
        color: #606266;
        vertical-align: top;
    }

    .file-icon-container {
        width: 36px;
        height: 45px;
        margin-top: -17px;
        background-size: cover;
        position: relative;
        cursor: pointer;
    }


    @media screen and (max-width: 1366px) {
        .value {
            width: 190px;
        }
        .file-icon-container {
            width: 27px;
            height: 36px;
            margin-top: -10px;
        }
    }
    @media screen and (max-width: 1280px) {
        .value {
            width: 166px;
        }
    }
</style>


<style>
    .value .el-input__inner {
        height: 28px;
        line-height: 28px;
    }
    .select_width {
        width: 139px;
    }
    .select_width1 {
        width: 250px;
    }
</style>


// WEBPACK FOOTER //
// src/views/order/SalesOrder/OrderItemView.vue